import React from 'react';
import { BodyText } from 'shared-portal-component';

import AccountOverviewCard from '@/components/organism/AccountOverview/AccountOverviewCard/AccountOverviewCard';

const SubscriptionBilling: React.FC = () => (
  <AccountOverviewCard title="Subscription & Billing">
    <BodyText as="p">Your subscription and billing details will appear here.</BodyText>
  </AccountOverviewCard>
);

export default SubscriptionBilling;
